export const LOGIN_CMPN = 'login'
export const LOGIN_NEW_CMPN = 'loginNew'
export const FORGETPASSWORD_CMPN = 'foret-password'
export const MAIN_CMPN = 'main'
export const DEVICE_MANAGE = 'device-manage'
export const GROUP_MANAGE = 'group-manage'
export const ORG_LIST = 'org-list'
export const USER_MANAGEMENT = 'user-management'
export const SKETCH_BOARD = 'sketch-board'
export const DATA_SOURCE = 'data-source'
export const MENU = 'menu'
export const ORGSETTING = 'org-setting'
export const USER = 'user'
export const SYSTEM_SETTING = 'system-setting'
export const USER_PROFILE = 'user-profile'
export const VERSION_INFORMATION = 'version-information'

export const PATH_LOGIN_CMPN = 'login'
export const PATH_LOGIN_NEW_CMPN = 'loginNew'
export const PATH_FORGETPASSWORD_CMPN = 'foretpassword'
export const PATH_MAIN_CMPN = 'main'
export const PATH_ORG_LIST = 'orglist'
export const PATH_USER_MANAGEMENT = 'usermanagement'
export const PATH_SKETCH_BOARD = 'sketchboard'
export const PATH_DATA_SOURCE = 'datasource'
export const PATH_MENU = 'menu'
export const PATH_ORGSETTING = 'orgSetting'
export const PATH_USER = 'user'
export const PATH_SYSTEM_SETTING = 'systemsetting'
export const PATH_USER_PROFILE = 'userprofile'
export const PATH_VERSION_INFORMATION = 'versioninformation'

export const CHP_DEV_TYPE = 1
export const EWH_DEV_TYPE = 2

export const ALARM_TYPE_SMS = 1
export const ALARM_TYPE_EMAIL = 2

export function getModuleName (cmpnName) {
  let moduleName = ''
  switch (cmpnName) {
    case LOGIN_CMPN:
      moduleName = LOGIN_CMPN
      break
    case FORGETPASSWORD_CMPN:
      moduleName = FORGETPASSWORD_CMPN
      break
    case GROUP_MANAGE:
      moduleName = GROUP_MANAGE
      break
    case DEVICE_MANAGE:
      moduleName = DEVICE_MANAGE
      break
    case ORG_LIST:
      moduleName = ORG_LIST
      break
    case USER_MANAGEMENT:
      moduleName = USER_MANAGEMENT
      break
    case SKETCH_BOARD:
      moduleName = SKETCH_BOARD
      break
    case MENU:
      moduleName = MENU
      break
    case USER:
      moduleName = USER
      break
    case SYSTEM_SETTING:
      moduleName = SYSTEM_SETTING
      break
    case USER_PROFILE:
      moduleName = USER_PROFILE
      break
    case VERSION_INFORMATION:
      moduleName = VERSION_INFORMATION
      break
  }
  return moduleName
}



// WEBPACK FOOTER //
// ./src/js/globalData.js